import _ from 'lodash';
import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';

import {
  DAILY_DEPOSIT_FORM_NAME,
  DAILY_DEPOSIT_FILTERS_FORM_NAME,
} from 'Common/FormEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { DailyDepositFieldEnum as Fields } from 'Common/FieldEnum';
import { computeTotal } from 'Common/Components/CashCalculator/helpers/compute';

import { extractDenominations } from '../../helpers/DailyDepositHelpers';

const root = state => _.get(state, 'DailyDepositState.DailyDeposit');

export const isDirtySelector = getIsDirty(DAILY_DEPOSIT_FORM_NAME);

export const getDailyDepositFormValues = getFormValues(DAILY_DEPOSIT_FORM_NAME);

export const getDailyDepositFilterValues = getFormValues(
  DAILY_DEPOSIT_FILTERS_FORM_NAME
);

export const getFetching = state => _.get(root(state), 'fetching', false);

export const getFetchError = state => _.get(root(state), 'fetchError');

export const getData = state => _.get(root(state), 'data');

export const getPrimarySites = state => _.get(root(state), 'primarySites', []);

export const getMealSummaries = state =>
  _.get(root(state), 'mealSummaries', []);

export const getWarnings = state => _.get(root(state), 'warnings', []);

export const getCEPErrors = state => _.get(root(state), 'CEPErrors', []);

export const getReport = state => _.get(root(state), 'report');

export const getChecks = createSelector(
  getDailyDepositFormValues,
  formValues =>
    _.get(formValues, Fields.Checks, []).map(check => ({
      ..._.mapKeys(check, (__, k) => _.camelCase(k)), //  Cash Calculator accepts lowercased keys, { amount: 111, description: 1233-4334 }
    }))
);

export const getDenominations = createSelector(
  getDailyDepositFormValues,
  formValues => extractDenominations(formValues)
);

export const getTotal = createSelector(
  getChecks,
  getDenominations,
  (checks, denominations) => computeTotal(denominations, checks)
);

export const getSaveSuccessful = state =>
  _.get(root(state), 'saveSuccessful', false);

export const getCloseSuccessful = state =>
  _.get(root(state), 'closeSuccessful', false);



// WEBPACK FOOTER //
// ./src/pages/dailydeposit/state/dailydeposit/selectors.js